import { ObservableStore } from 'packages/observable-store'

export const store = new ObservableStore()
store.set({ currentModal: null, stack: [], snacks: [] })
